import { ReactElement } from 'react';

import { dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { getVisitDraftTag } from '../../../../visit/visit.draft';
import { dischargeSummaryTranslationKeys } from '../../translations';
import { getDischargeSummaryDraftToken } from '../dischargeSummary.utils';

import { DischargeSummaryFormController } from './DischargeSummaryForm.types';

type DischargeSummaryFormRouteLeavingGuardProps = Pick<
   DischargeSummaryFormController,
   'formState' | 'handleSubmitDraft'
> & {
   readonly visitId: number;
};

export const DischargeSummaryFormRouteLeavingGuard = (
   props: DischargeSummaryFormRouteLeavingGuardProps
): ReactElement => {
   const { executeAsync: saveDischargeSummaryDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         // TODO RouteLeavingInterceptor dla draftów DREGAB-21474
         dispatchSnackbarNegativeEvent(dischargeSummaryTranslationKeys.draftSaveFail);
      },
   });
   return (
      <RouteLeavingGuard
         testId={'dischargeSummaryRouteLeavingGuard'}
         active={props.formState.isDirty}
         onLeave={props.handleSubmitDraft(async (formValues) => {
            return saveDischargeSummaryDraft({
               token: getDischargeSummaryDraftToken(props.visitId),
               tags: [getVisitDraftTag(props.visitId)],
               contents: formValues,
            });
         })}
         successMessage={dischargeSummaryTranslationKeys.draftSaveSuccess}
      />
   );
};
